const createAssessmentApi = (url, requestBody, token) => {
  const options = {
    method: "POST",
    body: JSON.stringify({ ...requestBody, self_audio_validation: 1 }),
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PATCH",
      Authorization: `Bearer ${token}`,
    },
  };

  return fetch(url, options).then((res) => {
    return res.json();
  });
};

export default createAssessmentApi;
